<template>
    <div class="class-attendance-report">
        <PreLoader v-if="isLoading"/>
        <div class="header-title">
            <h3>{{$t('report.attendance')}}</h3>
        </div>

        <v-form class="select-form select-clear-block" ref="form" style="align-items: flex-start; gap: 8px; flex-wrap: wrap; margin: 0">
            <div style="display: flex; flex-direction: row; gap: 8px; margin: 0; flex-wrap: nowrap">
                <v-select outlined dense :items="classes" item-text="classTitle" item-value="classId" :label="$t('class')" :no-data-text="$t('no_data')"
                          :rules="required" v-model="selectedClassId" class="v-select-item"/>
                <v-select outlined dense :items="schoolQuarters" item-text="semester" :no-data-text="$t('no_data')" item-value="id" :label="$t('quarter')"
                          :rules="required" v-model="selectedQuarterId" class="v-select-item"/>
            </div>
            <v-btn style="height: 40px" class="sf-btn" color="primary" @click="getAllClassStudents">{{$t('generate')}}</v-btn>
        </v-form>

        <div class="report-content" ref="report" v-if="classStudents.length">
            <div class="report-title">
                <h3 style="font-weight: bold" v-html="reportTitle"></h3>
            </div>
<!--            <table class="table bordered">-->
            <v-simple-table class="tab-st">
                <template v-slot:default>
                <thead>
                <tr>
                    <th style="font-weight: bold; font-size: 14px" class="num text-center">№</th>
                    <th style="font-weight: bold; font-size: 14px;" class="text-center">{{ $t('full_name') }}</th>
                    <th style="font-weight: bold; font-size: 14px" class="absent95 text-center">Н</th>
                    <th style="font-weight: bold; font-size: 14px" class="absent92 text-center">Н</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(student, i) in classStudents" :key="student.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ student.surname + ' ' + student.name }}</td>
                    <td :class="{'absent95': student.total95}">{{ student.total95 }}</td>
                    <td>{{ student.total92 }}</td>
                </tr>
                </tbody>
                </template>
            </v-simple-table>
<!--            </table>-->
        </div>
    </div>
</template>

<script>
import PreLoader from '@/components/preloader/PreLoader'
import AnalyticsService from '@/_services/analytics.service'
import { StudentService } from '@/_services/student.service'
const studentService = new StudentService()

export default {
  components: {
    PreLoader
  },
  props: {
    allChronicleYears: Array,
    classes: Array,
    schoolQuarters: Array
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    reportTitle () {
      if (this.$root.$i18n.locale === 'ru') {
        return 'Отчет <br> посещаемости за ' + this.selectedChronicleYear + ', четверть - ' + this.selectedQuarterTitle + ', школы<br> ' + this.school.nameRu
      } else return this.selectedChronicleYear + ' - жылдарга катышуунун отчету, ' + this.selectedQuarterTitle + ' - квартал, мектептер - ' + this.school.nameRu
    }
  },
  data () {
    return {
      required: [v => !!v || this.$t('required')],
      isLoading: false,
      classStudents: [],
      selectedQuarterId: '',
      selectedClassId: '',
      selectedChronicleYear: '',
      selectedQuarterTitle: ''
    }
  },
  methods: {
    getAllClassStudents () {
      if (this.$refs.form.validate()) {
        this.classStudents = []
        this.isLoading = true
        studentService.getByClass(this.selectedClassId).then((res) => {
          if (res.length) {
            this.classStudents = res
            this.generateReport()
          } else {
            this.$toast.info('Нет учеников!')
            this.isLoading = false
          }
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    generateReport () {
      this.selectedQuarterTitle = this.schoolQuarters.find(i => i.id === this.selectedQuarterId).semester
      this.selectedChronicleYear = this.allChronicleYears.find(i => i.id === this.school.chronicleId).selectorTitle
      AnalyticsService.getClassAttendanceCount(this.selectedClassId, this.selectedQuarterId).then((res) => {
        this.classStudents = this.classStudents.map((student) => {
          student.total92 = 0
          student.total95 = 0
          res.forEach((item) => {
            if (student.id === item.studentId) {
              student.total92 += item.total92
              student.total95 += item.total95
            }
          })
          return student
        }).sort((a, b) => (b.total92 + b.total95) - (a.total92 + a.total95))
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-st{
    width: max-content;
    margin: 0 auto;
}
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
.tab-st{
    min-width: 500px;
}
    .header-title {
        h3 {
            font-size: 25px;
        }
    }
    .v-select-item {
        max-width: 160px;
    }
    .report-content {
        text-align: center;
        margin-top: 25px;
        .report-title {
            text-align: center;
            margin-bottom: 25px;
        }
        .num {
            width: 40px;
            min-width: 40px;
            max-width: 40px;
        }
        .absent95 {
            color: #f50606;
            width: 50px;
            min-width: 50px;
            max-width: 50px;
        }
        .absent92 {
            color: #707683;
            width: 50px;
            min-width: 50px;
            max-width: 50px;
        }
        table {
            font-weight: bold;
            width: 900px;
            margin: 0 auto;
            td, th {
                padding: 0;
            }
        }
    }

    @media (max-width: 420px) {
        .v-select-item {
            max-width: none;
        }
        .sf-btn{
            width: 100%;
        }
        .tab-st{
            min-width: 200px;
        }
    }
</style>
